export default class StoreDeliveryZone{
    id: number = 0;
    isCustomerEligibleForDelivery: boolean = false;
    hasDeliveryRestrictions: boolean = false;         // has delivery restrictions -> no delivery until the total amount reaches a specific threshold
    hasFreeDelivery: boolean = false;                 // has free delivery 
    freeDeliveryThreshold: number = 0;         // threshold to get free delivery
    deliveryFees: number = 0;              // delivery fees
    deliveryThreshold: number = 0; 
    isProgrammedDeliveryEnabled: boolean = false; 
}